import { FC, HTMLAttributes } from 'react'
import cn from 'classnames'
import styles from 'components/features/future/FutureInputDecoration/FutureInputDecoration.styl'
import { useInputTheme } from 'components/features/theme/useInputTheme'

type FutureInputDecorationLabelProps =
  & HTMLAttributes<HTMLDivElement>
  & {
    label?: string
  }

export const FutureInputDecorationLabel: FC<FutureInputDecorationLabelProps> = (props) => {
  const { children, className, label, ...restProps } = props
  const { futureFieldTitle, inputActive, inputError } = useInputTheme()
  const labelClasses = cn(
    styles.label,
    styles[futureFieldTitle],
    {
      [styles.active]: inputActive,
      [styles.error]: inputError,
    },
    className
  )

  return (
    <div className={ labelClasses } { ...restProps }>
      { children || label }
    </div>
  )

}
